var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    width: 40,
    height: 40,
    style: {},
    filter: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.264 18.624c0.064-1.312 0.992-2.496 0.992-2.496 0.16-0.928-0.48-0.8-0.48-0.8-2.272 0.224-3.584 1.44-3.584 1.44-0.25 0.685-0.552 1.276-0.916 1.823l0.020-0.031c-1.344 1.984-3.264 3.264-3.264 3.264s-3.2-2.080-4.224-5.056c0 0-1.28-1.216-3.584-1.44 0 0-0.608-0.128-0.48 0.8 0 0 0.928 1.184 0.992 2.496 0 0-3.008 1.856-4.224 4.608 0 0-0.96 1.792-0.544 6.496 0 0 4.928 2.56 12.032 2.24 7.104 0.32 12.032-2.24 12.032-2.24 0.448-4.704-0.544-6.496-0.544-6.496-1.216-2.752-4.224-4.608-4.224-4.608zM21.536 14.944c2.976-1.728 2.688-4.288 2.688-4.288-0.224-0.416-0.64-0.352-0.64-0.352h-6.816c-0.704 0-0.672 1.024-0.672 1.024-0.128 2.88 2.176 3.584 2.176 3.584 2.016 0.704 3.264 0.032 3.264 0.032zM10.432 14.944s1.216 0.672 3.232-0.032c0 0 2.336-0.672 2.208-3.584 0 0 0.032-1.024-0.672-1.024h-6.816s-0.416-0.032-0.64 0.352c0 0-0.288 2.56 2.688 4.288zM29.664 7.2s-0.544-1.792-6.656-2.144c0 0-0.672-4.352-4.032-4.864-0.736-0.096-2.368-0.256-2.976-0.16-0.576-0.096-2.208 0.064-2.944 0.16-3.392 0.512-4.064 4.864-4.064 4.864-6.080 0.352-6.624 2.144-6.624 2.144-1.152 1.984 1.376 2.848 2.272 2.88 1.568 0.096 2.976-0.064 6.24-0.928l5.12-0.768s1.888-0.128 5.152 0.768 4.64 1.024 6.208 0.928c0.928-0.032 3.456-0.896 2.304-2.88z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeads);
export default __webpack_public_path__ + "static/media/leads.a03ba5cfa35e8d991dfaf85a9daad187.svg";
export { ForwardRef as ReactComponent };